module.exports = __webpack_public_path__ + "static/media/400127_02.14bc80c2.png";